export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_23.3cf271df.jpg";